import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=23b1efe4&scoped=true"
import script from "./TagsList.vue?vue&type=script&lang=ts"
export * from "./TagsList.vue?vue&type=script&lang=ts"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=23b1efe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1efe4",
  null
  
)

export default component.exports